import { AxiosResponse} from "axios";
import Api from "./api";

export default (): Promise<AxiosResponse> => {
    const path = 'package/membership-flow'
    return Api.getInstance().request.get(`${path}`, path)
}